import React, { useContext } from "react";
import "../../../assests/css/admin/Adminlogout.css";
import { FaSignOutAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { AppContext } from "../../../context/Appcontext";

const AdminLogout = () => {
  const navigate = useNavigate();
  const { setLoggedInAdmin } = useContext(AppContext);

  const handleLogout = () => {
    Swal.fire({
      icon: "success",
      title: "Logged Out!",
      text: "Your logout was successful",
      confirmButtonColor: "#6A88CE",
    }).then(() => {
      // Clear Admin Data
      localStorage.removeItem("admin");
      localStorage.removeItem("adminEmail");

      // Clear Context
      setLoggedInAdmin(null);

      // Redirect to Admin Login
      navigate("/login");
    });
  };

  const handleCancel = () => {
    navigate("/admin/dashboard");
  };

  return (
    <div className="admin-logout-page">
      <div className="admin-logout-card">
        <FaSignOutAlt className="admin-logout-icon" />

        <h1 className="admin-logout-title">Logout</h1>

        <p className="admin-logout-text">
          Are you sure you want to logout? Your progress is saved.
        </p>

        <div className="admin-logout-btns">
          <button
            className="admin-logout-confirm"
            onClick={handleLogout}
          >
            Yes, Logout
          </button>

          <button
            className="admin-logout-cancel"
            onClick={handleCancel}
          >
            Cancel
          </button>
        </div>

        <p className="admin-logout-note">👋 See you soon!</p>
      </div>
    </div>
  );
};

export default AdminLogout;